import React from 'react'
import LxNav from '../../LxNav/One'
// import { Link } from 'react-router-dom'
import LxOutLogin from '../../LxOutLogin'
import styles from './index.module.scss'
import defaultSetting from '@/setting'
import { hasLoginApi } from '@/api'
const logo = require('@/assets/images/logo.png')
const deepColor = 'rgba(34, 34, 34, 0.65)'

class Header extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            userInfo: {}
        }
    }
    componentDidMount() {
        hasLoginApi().then(res => {
            this.setState({
                userInfo: res.data
            })
        })
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop < 50 || scrollTop === 50 ) {
            this.setState({
                isToggle: false
            })
        } else {
            this.setState({
                isToggle: true
            })
        }
    }
    render() {
        return (
            <React.Fragment>
                <header className={`header lx-bg-color-white lx-flex-row ${styles.header}`}>
                    <div className="lx-flex-shrink-0 logo-wrap lx-hidden lx-fz0">
                        <img className="lx-h100" src={logo} alt="logo" />
                    </div>
                    <div className="lx-flex-grow-1 header-middle">
                        <LxNav></LxNav>
                    </div>
                    <div className="lx-flex-shrink-0 header-right">
                        {
                            this.state.userInfo.userName?(
                                <LxOutLogin {...this.state.userInfo} titleColor={deepColor}></LxOutLogin>
                            ):(
                                <div className="handle-wrap lx-flex-row">
                                    {/* <a href={`/${defaultSetting.suiteKey}/pb/logAndReg.html?modalType=0`} className="handle-btn-login lx-fz14" rel="noreferrer">注册</a> */}
                                    <a href={`/${defaultSetting.suiteKey}/pb/logAndReg.html?modalType=0`} className="handle-btn-register lx-fz14 lx-ml20" rel="noreferrer">注册/登录</a>
                                </div>
                            )
                        }
                    </div>
                </header>
                <div className="headerPlaceholder" style={{width: '100%', height: 80}}/>
            </React.Fragment>
        )
    }
}
  
  export default Header;